// node-modules
import Odometer from 'odometer';
import ScrollMagic from 'scrollmagic';

// constants
import { SELECTORS } from '@/scripts/constants';

// other
import { selectors } from '@/scripts/animation';
import { controller } from '@/components/_scrollmagic';

// assets
import 'odometer/themes/odometer-theme-default.css';
import './counter.scss';

const getAssets = el => ({
  counter: el.querySelector(selectors.counterNumber),
});

const initOdometer = (el, frac) => new Odometer({
  el,
  value: 0,
  format: frac ? `(ddd).${frac.split('').map(() => 'd').join('')}` : 'd',
});

export default function counterScene(container) {
  const scenes = [];
  container.querySelectorAll('[data-animation*="counter-item"]')
    .forEach((wrapper) => {
      const { counter } = getAssets(wrapper);
      let odometer;
      if (counter) {
        const text = $(counter).text();
        if (!isNaN(text)) { // eslint-disable-line no-restricted-globals
          const [, frac] = text.split('.');
          $(counter).data('value', text);
          odometer = initOdometer(counter, frac);
        }
      }

      scenes.push(new ScrollMagic.Scene({
        triggerElement: wrapper,
        triggerHook: 'onEnter',
        offset: 50,
        reverse: false,
      })
        .on('start', () => {
          if (odometer) {
            odometer.update($(counter).data('value'));
          }
          $(wrapper).addClass(SELECTORS.loaded);
        })
        // .addIndicators({name: 'Counter'})
        .addTo(controller));
    });
  return scenes;
}



// WEBPACK FOOTER //
// ./components/_scrollmagic/scenes/counter/counter.js